import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../../sensorconfig.axios";

interface OperatorSkillScoreState {
  OperatorSkillScore: {
    load: boolean;
    data: [];
  };
}

export const OperatorSkillScoreSlice = createSlice({
  name: "OperatorSkillScore",
  initialState: {
    OperatorSkillScore: {
      load: false,
      data: [],
    },
  } as OperatorSkillScoreState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWarehouserSkillScore.pending, (state) => {
        state.OperatorSkillScore.load = true;
      })
      .addCase(getWarehouserSkillScore.fulfilled, (state, action) => {
        state.OperatorSkillScore.data = action.payload;
        state.OperatorSkillScore.load = false;
      })
      .addCase(getWarehouserSkillScore.rejected, (state) => {
        state.OperatorSkillScore.load = false;
      })
      .addCase(getOperatorSkillScore.pending, (state) => {
        state.OperatorSkillScore.load = true;
      })
      .addCase(getOperatorSkillScore.fulfilled, (state, action) => {
        state.OperatorSkillScore.data = action.payload;
        state.OperatorSkillScore.load = false;
      })
      .addCase(getOperatorSkillScore.rejected, (state) => {
        state.OperatorSkillScore.load = false;
      });
  },
});

export default OperatorSkillScoreSlice.reducer;

export const getWarehouserSkillScore = createAsyncThunk(
  "OperatorSkillScore/getWarehouserSkillScore",
  async (param: any) => {
    try {
      var data: any; 
      data = await DataServer.patch("/api/skill_score/v1/byWarehouse?warehouse_id=" + param.apiParam.warehouse_id);
     
      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const getOperatorSkillScore = createAsyncThunk(
  "OperatorSkillScore/getOperatorSkillScore",
  async (param: any) => {
    try {
      var data = await DataServer.patch("/api/skill_score/v1/byOperator?warehouse_id=" + param.apiParam.warehouse_id + "&user_id=" + param.apiParam.user_id);
      
      return data.data;
    } catch (error) {
      return error;
    }
  }
);
